import React, { CSSProperties } from "react";
import { DataUser } from "../../types";
import { Text } from "@jarvis-catalyst/ui-components";
import { useUtils } from "../../hooks/useUtils";
import { REASON_DESCRIPTION } from "../../config/constants";

type Props = {
  users?: DataUser[];
};

const styleMatchServiceProvider: CSSProperties = {
  borderRadius: "5px",
  padding: "10px",
  boxShadow: "0 0 10px #d33"
};

const UsersTab = ({ users }: Props): JSX.Element => {
  const { serviceProvider, userName } = useUtils();
  return (
    <>
      {users?.map((user, index) => {
        const isUserMatched =
          serviceProvider === user.serviceProvider && userName?.replace(/[-]/gi, "") === user.userName;
        const passwordStatus =
          user.requiredActions?.[0] === 'UPDATE_PASSWORD' ? 'Bloqueado por seguridad' : null; 
        return (
          <div key={index}>
            <div style={isUserMatched ? styleMatchServiceProvider : {}}>
              <div className="row">
                <div className="col">
                  <Text className="">User Name</Text>
                  <input type="text" className="form-control" disabled value={user.userName} />
                </div>

                <div className="col">
                  <Text className="">Enabled</Text>
                  <input type="text" className="form-control" disabled value={String(user.enabled)} />
                </div>
              </div>

              <div className="row">
                {
                  (passwordStatus) ? (
                    <div className="col">
                      <Text className="">Password status</Text>
                      <input type="text" className="form-control" disabled value={String(passwordStatus)} />
                    </div>
                ) : (
                  <div className="col"></div>
                  )
                }
                
                {
                  !user.enabled ? (
                <>
                    <div className="col">
                      <Text className="">Reason</Text>
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        value={
                          REASON_DESCRIPTION[user.disabledReason[0] as keyof typeof REASON_DESCRIPTION] ??
                          "RAZON DESCONOCIDA"
                        }
                      />
                    </div>
                </>
                  ) : (
                    <div className="col"></div>
                  )
                }
              </div>
            </div>
            {users.length > 1 ? <hr /> : <br />}
          </div>
        );
      })}
    </>
  );
};

export default UsersTab;
